import { InjectionToken } from '@angular/core';

export const SPRINKLR_APP_ID = new InjectionToken<string>('Sprinklr App ID');
